import { Button, Col, Input, message, Modal, Row, Spin, DatePicker } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash.debounce';
import Pagination from '@/components/pagination';
import CheckBox from './components/check-box';
import { calendarIcon, searchIcon } from '@/constants/static';
import { disabledDate } from '@/utils/publicMethod';
import dayjs from 'dayjs';
import couponApi from '@/api/coupon';
const { RangePicker } = DatePicker;
interface SearhParams {
    pageNum: number;
    pageSize: number;
    startTime: string;
    endTime: string;
    keyword: string;
    noSelect: string;
    sortColumn: string;
    sortAsc: boolean;
}
interface CustomerItem {
    customerId: string;
    fullName: string;
    email: string;
    mobile: string;
    tasks: string;
    status: string;
    customerSince: string;
    gender: number;
}
function ConpouCustomerModal({ customerModal, setCustomerModal, defaultCustomers, addCustomer }) {
    const [totalRecord, setTotalRecord] = useState(0);
    const popupContainer = document.getElementById('select-bar') || document.body;
    const [loading, setLoading] = useState(false);
    const [listParams, setListParams] = useState<SearhParams>({
        pageNum: 1,
        pageSize: 10,
        startTime: '',
        endTime: '',
        keyword: '',
        noSelect: '',
        sortColumn: '',
        sortAsc: true,
    });
    const [tableData, setTableData] = useState<CustomerItem[]>([]);
    const inputChange = e => {
        debouncedSave({ ...listParams, keyword: e.target.value, pageNum: 1 });
    };
    const debouncedSave = useCallback(
        debounce(nextValue => setListParams(nextValue), 1500),
        []
    );
    async function getCustomers(params) {
        setLoading(true);
        try {
            const res = await couponApi.getCouponCustomers(params);
            const list = res.data.records.map(item => {
                const k = selCustomers.findIndex(v => v.customerId === item.customerId);
                return Object.assign(item, {
                    customerSince: item.customerSince ? window.utils.formatTimeMDY(item.customerSince) : '-',
                    mobile: item.mobile ? window.utils.formatMobileNumber(item.mobile) : '-',
                });
            });
            setTableData(list);
            setTotalRecord(+res.data.total);
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    }
    const handlePageChange = prop => {
        setListParams(state => ({ ...state, pageNum: prop }));
    };
    const dateOnChange = date => {
        setListParams({
            ...listParams,
            pageNum: 1,
            startTime: date ? dayjs(`${dayjs(date[0]).format('YYYY-MM-DD')} 00:00:00`).toISOString() : '',
            endTime: date ? dayjs(`${dayjs(date[1]).format('YYYY-MM-DD')} 23:59:59`).toISOString() : '',
        });
    };
    useEffect(() => {
        if (!customerModal) {
            setIsOnlyShowSel(false);
            setAllCustomers([]);
        }
        setListParams({
            pageNum: 1,
            pageSize: 10,
            startTime: '',
            endTime: '',
            keyword: '',
            noSelect: '',
            sortColumn: '',
            sortAsc: true,
        });
        if (customerModal) {
            setSelCustomers(defaultCustomers);
        }
    }, [customerModal]);
    useEffect(() => {
        if (customerModal) {
            getCustomers(listParams);
            listParams.pageNum === 1 && getAllCustomers({ ...listParams, pageSize: -1 });
        }
    }, [listParams]);
    const getAllCustomers = async params => {
        try {
            const res = await couponApi.getCouponCustomers(params);
            setAllCustomers(res.data.records);
            if (selAll) {
                setSelCustomers(res.data.records);
            }
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    };
    const [isOnlyShowSel, setIsOnlyShowSel] = useState(false);
    useEffect(() => {
        if (isOnlyShowSel) {
            const unSel = allCustomers.filter(i => !selCustomers.find(s => s.customerId === i.customerId));
            console.log('unSel', unSel.length);
            setListParams({ ...listParams, pageNum: 1, noSelect: unSel.map(i => i.customerId).join(',') });
        } else {
            setListParams({ ...listParams, pageNum: 1, noSelect: '' });
        }
    }, [isOnlyShowSel]);
    const [selCustomers, setSelCustomers] = useState<CustomerItem[]>([]);
    const [allCustomers, setAllCustomers] = useState<CustomerItem[]>([]);
    const changeCustomerSel = (item: CustomerItem, index: number) => {
        const existential = selCustomers.find(s => s.customerId === item.customerId);
        if (existential) {
            setSelCustomers(state => state.filter(i => i.customerId !== item.customerId));
        } else {
            setSelCustomers(state => [...state, item]);
        }
    };
    const [selAll, setSelAll] = useState(false);
    const changeAllSel = val => {
        if (val) {
            setSelCustomers(allCustomers);
        } else {
            setSelCustomers([]);
        }
    };
    useEffect(() => {
        const ine = allCustomers.filter(a => selCustomers.some(i => a.customerId === i.customerId));
        if (
            selCustomers.length > 0 &&
            ine.length === selCustomers.length &&
            selCustomers.length === allCustomers.length
        ) {
            setSelAll(true);
        } else {
            setSelAll(false);
        }
    }, [selCustomers, allCustomers]);
    return (
        <div>
            <Modal
                width={1120}
                maskClosable={false}
                centered={true}
                open={customerModal}
                destroyOnClose
                style={{ margin: '24px 0' }}
                onCancel={() => setCustomerModal(false)}
                closeIcon={<img src={require('@/assets/images/Icons_Cross.png')} style={{ width: 24, height: 24 }} />}
            >
                <div className="modal-title" style={{ marginTop: 0 }}>
                    Allocate Customer Coupon
                </div>
                <div className="page-main page-main-modal" style={{ border: 'none' }}>
                    <div className="select-bar">
                        <div className="flex-left">
                            <CheckBox
                                value={isOnlyShowSel}
                                handChange={val => {
                                    if (selAll || selCustomers.length) setIsOnlyShowSel(val);
                                }}
                                disabled={!selCustomers.length && !selAll}
                            />
                            <span style={{ marginLeft: 12 }}>View Selected Users Only</span>
                        </div>
                        <div className="flex-left" style={{ marginLeft: 'auto' }}>
                            <RangePicker
                                style={{ width: 290, marginRight: 16 }}
                                className="search-input"
                                placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                                suffixIcon={calendarIcon}
                                separator={'-'}
                                format={'DD/MM/YYYY'}
                                disabledDate={disabledDate}
                                onChange={dateOnChange}
                                getPopupContainer={() => popupContainer}
                            />
                            <Input
                                style={{ width: 290 }}
                                className="search-input"
                                placeholder="Search"
                                onChange={inputChange}
                                prefix={searchIcon}
                            />
                        </div>
                    </div>
                </div>
                <div className="modal-tip tip-font-16 page-main page-main-modal" style={{ margin: '8px 0 0 0' }}>
                    {loading ? (
                        <div className="data_loading flex-center">
                            <Spin />
                        </div>
                    ) : (
                        <>
                            <div className="table" style={{ textAlign: 'left' }}>
                                {totalRecord ? (
                                    <>
                                        <div className="table-th">
                                            <Row>
                                                <Col span={2}>
                                                    <CheckBox value={selAll} handChange={() => changeAllSel(!selAll)} />
                                                </Col>
                                                <Col span={5}>Full Name</Col>
                                                <Col span={5}>Email</Col>
                                                <Col span={3}>Mobile</Col>
                                                <Col span={3} style={{ display: 'flex', columnGap: 6 }}>
                                                    Tasks{' '}
                                                    <SortCom
                                                        word="Tasks"
                                                        sortColumn={listParams.sortColumn}
                                                        sortAsc={listParams.sortAsc}
                                                        onChange={({ sortColumn, sortAsc }) =>
                                                            setListParams(state => ({
                                                                ...state,
                                                                pageNum: 1,
                                                                sortColumn,
                                                                sortAsc,
                                                            }))
                                                        }
                                                    />
                                                </Col>
                                                <Col span={4} style={{ display: 'flex', columnGap: 6 }}>
                                                    Customer Since{' '}
                                                    <SortCom
                                                        word="Customer Since"
                                                        sortColumn={listParams.sortColumn}
                                                        sortAsc={listParams.sortAsc}
                                                        onChange={({ sortColumn, sortAsc }) =>
                                                            setListParams(state => ({
                                                                ...state,
                                                                pageNum: 1,
                                                                sortColumn,
                                                                sortAsc,
                                                            }))
                                                        }
                                                    />
                                                </Col>
                                                <Col span={2}>Status</Col>
                                            </Row>
                                        </div>
                                        {tableData.map((item, index) => (
                                            <Row className="table-tr" key={item.customerId}>
                                                <Col span={2}>
                                                    <CheckBox
                                                        value={
                                                            selCustomers.find(s => s.customerId === item.customerId)
                                                                ? true
                                                                : false
                                                        }
                                                        handChange={() => changeCustomerSel(item, index)}
                                                    />
                                                </Col>
                                                <Col span={5}>
                                                    {item.fullName || '-'}{' '}
                                                    {Number(item.gender) > 0 && (
                                                        <img
                                                            src={require(`@/assets/images/${
                                                                Number(item.gender) === 1 ? 'male' : 'female'
                                                            }@2x.png`)}
                                                            width={12}
                                                            style={{ marginLeft: 8 }}
                                                        />
                                                    )}
                                                </Col>
                                                <Col span={5}>{item.email || '-'}</Col>
                                                <Col span={3}>{item.mobile}</Col>
                                                <Col span={3}>{item.tasks || '0'}</Col>
                                                <Col span={4}>{item.customerSince || '-'}</Col>
                                                <Col
                                                    span={2}
                                                    style={{
                                                        color: item.status === 'Inactive' ? '#F94D85' : '#7DB8A4',
                                                    }}
                                                >
                                                    {item.status === 'Inactive' ? 'Inactive' : 'Active'}
                                                </Col>
                                            </Row>
                                        ))}
                                    </>
                                ) : (
                                    <div className="no-data flex-center">No data</div>
                                )}
                            </div>
                        </>
                    )}
                </div>
                <div>
                    <Pagination total={totalRecord} pageChange={handlePageChange} pageNo={listParams.pageNum} />
                </div>
                <div className="flex-end" style={{ marginTop: 24 }}>
                    <Button
                        style={{ width: 138, height: 46, marginRight: 12 }}
                        onClick={() => setCustomerModal(false)}
                        className="cancel-btn"
                    >
                        Cancel
                    </Button>
                    <Button
                        style={{ width: 214, height: 46 }}
                        type="primary"
                        onClick={() => addCustomer(selCustomers)}
                        disabled={!selCustomers.length}
                    >
                        Selected {selCustomers.length} customer{selCustomers.length > 1 && 's'}
                    </Button>
                </div>
            </Modal>
        </div>
    );
}

export default ConpouCustomerModal;
const SortCom = ({ word, sortAsc, sortColumn, onChange }) => {
    const isSortAsc = sortColumn === word && sortAsc === true;
    const isSort = sortColumn ? sortColumn === word : false;
    const clickableAsc = !isSort || !isSortAsc;
    const clickableDesc = !isSort || isSortAsc;
    return (
        <div style={{ display: 'grid', rowGap: 2 }}>
            <img
                src={require(`@/assets/images/selected.png`)}
                width={12}
                style={{
                    transformOrigin: 'center',
                    transform: 'rotateZ(180deg)',
                    cursor: clickableAsc ? 'pointer' : 'no-drop',
                    opacity: clickableAsc ? '0.5' : 1,
                }}
                onClick={() => clickableAsc && onChange({ sortColumn: word, sortAsc: true })}
            />
            <img
                src={require(`@/assets/images/selected.png`)}
                width={12}
                style={{
                    cursor: clickableDesc ? 'pointer' : 'no-drop',
                    opacity: clickableDesc ? '0.5' : 1,
                    marginTop: '-8px',
                }}
                onClick={() => clickableDesc && onChange({ sortColumn: word, sortAsc: false })}
            />
        </div>
    );
};
